$( document ).ready(function() {
   
  //fire up fancy box
  $('[data-fancybox="gallery"]').fancybox({
    
  });
  
  $('.navigation-container').click(function(){
  	let el = $(this).data('slide');
    
    $('.navigation-container').removeClass('active');
    $(this).addClass('active');
    
    $('#' + el).click();
  })
  
  //hero slier 
  $('.slick-slider-hero').slick({
      dots: true,
      infinite: true,
      speed: 500,
      fade: false,
      arrows: true
  });
  
  //collection slick slider 
  $('.slick-slider-collection').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  });
  
  
  //collection slick slider 
  $('.slick-slider-products').slick({
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 4,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  
  });
  
  //collection slick slider 
  $('.slick-slider-reviews').slick({
    dots: false,
    infinite: false,
    speed: 300,
    slidesToShow: 3,
    slidesToScroll: 1,
    arrows: true,
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true
        }
      },
      {
        breakpoint: 600,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }     
    ]
  });
  
  //mantel slick slider 
  $('.mantel-slider').slick({  
    dots: false,
    infinite: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    adaptiveHeight: true  
  });
  
 //mantel image swapper 
 $('#mantel-thumbnails a').click(function(e){
   
 	e.preventDefault();
    let imageURL = $(this).data('mantel-image-url'); 
  
    $('#mantel-thumbnails a').removeClass('active');
    $(this).addClass('active');
    //now swap the featured image url 
    $('#active-mantel-image').attr('src',imageURL);
  
 });
  
  
 //product info swapper 
  $('.details-tab').click(function(e){
    e.preventDefault;
    let el = $(this).data('tab');   
    $('.details-tab').removeClass('active');
    $(this).addClass('active');  
    $('.details-box').removeClass('active');   
    $('#' + el).addClass('active');      
  });
  
  //mantels cutting  
  $('#cut-question').click(function(){
 	$('#cut-popup').addClass('active');
  })
  
  $('#cut-left').click(function(){
  	$(this).addClass('active');  
  });
   
  $('#cut-right').click(function(){
  	$(this).addClass('active');  
  });
  
  $('#remove-cut').click(function(){
    let elCut =  $('#hidden-mantel-length').text();
  	$('.cut-line').remove();
   
    $('#mantel-total-length').text(elCut);
  })
  
  
  $('#mantel-box-container').click(function(e){
      var xPosition = e.clientX;
      var yPosition = e.clientY;
      var centerLine = window.innerWidth / 2;
    
      var popupWindowPositionLeft =  $('#cut-popup').position();    
      var popupWindowPositionRight =  $('#cut-popup').position() - centerLine;
    
    
    if(xPosition > centerLine){
      
        let dFromRight =  xPosition;
      
        if($('#cut-line-right').length > 0){
          $('#cut-line-right').remove();
        }
      
        jQuery('<div>', {
            id: 'cut-line-right',
            class: 'cut-line',  
            style: 'left:' + xPosition + 'px !important',
            xPosition: xPosition
        }).appendTo('#mantel-box-container');
      
    } else {
      
        if($('#cut-line-left').length > 0){
          $('#cut-line-left').remove();
        }
      
        jQuery('<div>', {
          id: 'cut-line-left',
          class: 'cut-line',       
          style: 'left:' + xPosition + 'px !important',
          xPosition: xPosition
        }).appendTo('#mantel-box-container');
      
    }
    
    getCutLength();
    
  });
 
  
  //On the click to finish, run the cut function 

  
    
    
  //fire up the AOS
  AOS.init();


  //Navigation Filter Dropwdowns
  $('.filter-top .Collapsible__Button').click(function(){
    
    //check for active headline    
    if($(this).hasClass('active')){ 
       $('.filter-top .Collapsible__Inner').removeClass('active');
       $(this).removeClass('active'); 
    } else {     
      //clear all the top buttons
      $('.filter-top .Collapsible__Button').removeClass('active');
      
      //add active class to the the link
      $(this).addClass('active');  
  	  
      //remove the filter actives 
      $('.filter-top .Collapsible__Inner').removeClass('active');

      $(this).closest('.filter-top').find('.Collapsible__Inner').addClass('active');
    }
  })
  
  
    
  $('#video-popup-button').click(function(e){
    e.preventDefault(); 
    $('#video-popup').addClass('active');
  })
                                 
  $('#video-popup .close').click(function(e){
  	$('#video-popup').removeClass('active');   
  })
  
  
  //form popup and sumbit
  $('#request-quote-button').click(function(e){
    e.preventDefault();   
    $('#request-quote-pop').addClass('active');
  })
  
  $('.request-modal-close').click(function(){
  	$('#request-quote-pop').removeClass('active');
  })
  
  

  $('#inquiry-form').submit(function(e){
    
  	e.preventDefault();    
    
    //popup form send
    var iform = $('#inquiry-form');

    $.ajax({
          type: 'POST',
          async: true,
          url: '/contact',
          data: iform.serialize(),
          beforeSend: function() {
            iform.addClass('sending'); 
          },
          error: function(responseerror) {
              console.log(responseerror.error.status);
              if(responseerror.status == 429) {
                var challengeUrl = window.location.origin +'/challenge#inquiry-form'
                window.location = challengeUrl           
              }
              iform.addClass('error');
          },
          success: function(response) {
         	$('#inquiry-success-form').addClass('active');  
            setTimeout(function(){
              $('.request-modal-close').first().click();
            }, 2000)
          }
     }); 
    
  });

  
  
  //footer menu box
  $('.foot-menu-box').click(function(){
  	$(this).find('ul').first().toggleClass('active');
    $(this).find('h3').first().toggleClass('active');
  });
  
  
  //homepage scrolling functoin
  
  $(window).scroll(function(event) {
     
     var fullHomeHeight = $(window).height();
     var scroll = $(window).scrollTop();

     if (scroll >= (300)) {
     	$('#header-incentive').addClass('active');
     } else {
        $('#header-incentive').removeClass('active');
     }     
   });
  
  
  //samples hover
  $('#hover-dallas').mouseover(function(){
  	$('#houston-showroom').addClass('hide-img');  
  })
  
  $('#hover-dallas').mouseleave(function(){
  	$('#houston-showroom').removeClass('hide-img');  
  })

 
  /* Functions to use 
  ----------------------------*/
  
  
   function getCutLength(){
    
    //get the length in inches from the mantel
    let elLength = parseFloat($('#hidden-mantel-length').text()).toFixed(2);    
    
    //get the final cut lengths
    let finalCutFromLeft = 0;
    let finalCutFromRight = 0;
    let finalMantelLength = elLength;
    
    //get the screen width 
    let screenWidth = window.innerWidth;
    
    if($('#cut-line-left').length > 0){
    	let cutLeft = $('#cut-line-left').attr('xPosition');       
        let percentageFromLeft = ( screenWidth - cutLeft ) / screenWidth;        
        finalCutFromLeft = parseFloat((( elLength * percentageFromLeft ) - elLength) * -1).toFixed(2);       
    }
    
    if($('#cut-line-right').length > 0){
		let cutRight = $('#cut-line-right').attr('xPosition');        
        let percentageFromRight = ( screenWidth - cutRight ) / screenWidth;        
        finalCutFromRight = parseFloat(elLength * percentageFromRight).toFixed(2);
    }
    

    //get the total length of the mantel after cuts
    finalMantelLength = parseInt(elLength - ( parseInt(finalCutFromRight) + parseInt(finalCutFromLeft) ));   
 
    $('input#mantel-cut').val(finalMantelLength + ' Inches Total Length');
     
    $('#mantel-total-length').text(finalMantelLength); 
    
    //set the cut from left note
    if(finalCutFromLeft > 0){
    	$('input#mantel-cut-left').val( 'Cut ' + finalCutFromLeft + ' Inches From Left Side'); 
      
    } else {
    	$('input#mantel-cut-left').val( 'No Left Cut');       
    }
    
    //set the cut from right note
    if(finalCutFromRight > 0){
    	$('input#mantel-cut-right').val( 'Cut ' + finalCutFromRight + ' Inches From Right Side'); 
      
    } else {
    	$('input#mantel-cut-right').val( 'No Right Cut');       
    }
    
    
  }
  
  
  
});
